import React from 'react';
import {Route, Routes, Outlet} from 'react-router-dom';
import {SuspensedView} from '@/components/SuspensedView';

import {DateRangeProvider} from './hooks/useDateRange';
import {WebsiteProvider} from './hooks/useWebsite';
import OverviewPage from './overview/OverviewPage';
import ReportsPage from './reports/ReportsPage';
import PagesReportPage from './pages-report/PagesReportPage';
import DevicesPage from './devices/DevicesPage';

const AnalyticsRouter = () => (
  <Route
    path='analytics/*'
    element={
      <SuspensedView>
        {/*<WebsiteProvider websiteId="691d9f2e426eb5d7cc086891">*/}
        <WebsiteProvider>
          <DateRangeProvider
            defaultRange="week"
            minDate={new Date('2025-11-01')}
            maxDate={new Date()}
          >
            <Routes>
              <Route element={<Outlet />}>
                <Route path='/overview' element={<OverviewPage />} />
                <Route path='/reports' element={<ReportsPage />} />
                <Route path='/pages-report' element={<PagesReportPage />} />
                <Route path='/devices' element={<DevicesPage />} />
              </Route>
            </Routes>
          </DateRangeProvider>
        </WebsiteProvider>
      </SuspensedView>
    }
  />
);

export default AnalyticsRouter;
